"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var operation_models_1 = require("../../model/operation-models");
var document_operations_service_1 = require("../../../../shared/services/api/document-operations.service");
var base_drawer_control_component_1 = require("../../base-drawer-control.component");
var operators_1 = require("rxjs/operators");
var editor_common_model_1 = require("./model/editor-common-model");
var converted_document_1 = require("../../../../shared/model/converted-document");
var convert_operation_dto_1 = require("../../../../shared/model/document-operation/convert-operation-dto");
var create_operation_dto_1 = require("../../../../shared/model/document-operation/create-operation-dto");
var drawer_events_manager_service_1 = require("../../services/drawer-events-manager.service");
var static_method_1 = require("../../../../shared/utils/static-method");
var file_utils_1 = require("../../../../shared/utils/file-utils");
var DocumentEditorCaseComponent = /** @class */ (function (_super) {
    __extends(DocumentEditorCaseComponent, _super);
    function DocumentEditorCaseComponent(documentOperationsService, drawerEventsManagerService) {
        var _this = _super.call(this) || this;
        _this.documentOperationsService = documentOperationsService;
        _this.drawerEventsManagerService = drawerEventsManagerService;
        _this.spacingModel = new editor_common_model_1.LayoutSpacingModel();
        return _this;
    }
    DocumentEditorCaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.documentOperationsService.convertDocument(this.data.attachmentId, this.data.categoryId, this.data.entityId, this.data.fieldId, 'html', new convert_operation_dto_1.ConvertOperationDto(false, true))
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (data) {
            _this.content = static_method_1.base64ToUTF8(data.content);
            _this.paperFormat = data.properties[converted_document_1.PAPER_FORMAT];
            _this.orientation = data.properties[converted_document_1.ORIENTATION];
            _this.width = _this.pointToCM(data.properties[converted_document_1.WIDTH]);
            _this.height = _this.pointToCM(data.properties[converted_document_1.HEIGHT]);
            _this.spacingModel = new editor_common_model_1.LayoutSpacingModel(_this.pointToCM(data.properties[converted_document_1.LEFT_MARGIN]), _this.pointToCM(data.properties[converted_document_1.RIGHT_MARGIN]), _this.pointToCM(data.properties[converted_document_1.TOP_MARGIN]), _this.pointToCM(data.properties[converted_document_1.BOTTOM_MARGIN]));
            _this.isReady = true;
            _this.drawerEventsManagerService.onInitComplete.next(true);
        });
        this.subscribeToSaveEvent();
    };
    DocumentEditorCaseComponent.prototype.getControlHeight = function () {
        var sidenavHeight = document.getElementById('drawerSidenav').offsetHeight;
        var toolbarHeight = document.getElementById('drawerToolbar').offsetHeight;
        return (sidenavHeight && toolbarHeight) ? sidenavHeight - toolbarHeight : 700;
    };
    DocumentEditorCaseComponent.prototype.handleValueChange = function (e) {
        this.editedDataModel = e.detail;
    };
    DocumentEditorCaseComponent.prototype.subscribeToSaveEvent = function () {
        var _this = this;
        this.drawerEventsManagerService.onSaveTrigger
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (data) {
            _this.saveChanges();
        });
    };
    DocumentEditorCaseComponent.prototype.saveChanges = function () {
        var _this = this;
        this.documentOperationsService.getInfo(this.data.attachmentId)
            .pipe(operators_1.switchMap(function (info) {
            var isConfirmed = !!info.entityId;
            var result;
            var fileName = file_utils_1.getNewVersionedFileName(info.name, isConfirmed);
            if (_this.editedDataModel) {
                result = new create_operation_dto_1.CreateOperationDto(fileName, info.categoryId, info.metaData, static_method_1.utf8ToBase64(_this.editedDataModel.content), _this.editedDataModel.orientation, _this.editedDataModel.paperFormat, _this.cmToPoint(_this.editedDataModel.height), _this.cmToPoint(_this.editedDataModel.width), _this.cmToPoint(_this.editedDataModel.spacingModel.top), _this.cmToPoint(_this.editedDataModel.spacingModel.bottom), _this.cmToPoint(_this.editedDataModel.spacingModel.left), _this.cmToPoint(_this.editedDataModel.spacingModel.right));
            }
            else {
                result = new create_operation_dto_1.CreateOperationDto(fileName, info.categoryId, info.metaData, static_method_1.utf8ToBase64(_this.content), _this.orientation, _this.paperFormat, _this.height, _this.width, _this.spacingModel.top, _this.spacingModel.bottom, _this.spacingModel.left, _this.spacingModel.right);
            }
            return _this.documentOperationsService.createDocument(result, 'docx');
        }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (id) {
            _this.drawerEventsManagerService.onSaveComplete.next(id);
        });
    };
    DocumentEditorCaseComponent.prototype.pointToCM = function (point) {
        // 1 point equal 0.0352777778 cm
        return Number((point * 0.0352777778).toFixed(2));
    };
    DocumentEditorCaseComponent.prototype.cmToPoint = function (cm) {
        // 1 cm equal 28.3465 point
        return Math.ceil(cm * 28.3465);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", operation_models_1.DocumentOperationModel)
    ], DocumentEditorCaseComponent.prototype, "data", void 0);
    DocumentEditorCaseComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-document-editor-case',
            styles: [require('./document-editor-case.component.css')],
            template: require('./document-editor-case.component.html')
        }),
        __metadata("design:paramtypes", [document_operations_service_1.DocumentOperationsService,
            drawer_events_manager_service_1.DrawerEventsManagerService])
    ], DocumentEditorCaseComponent);
    return DocumentEditorCaseComponent;
}(base_drawer_control_component_1.BaseDrawerControlComponent));
exports.DocumentEditorCaseComponent = DocumentEditorCaseComponent;
//# sourceMappingURL=document-editor-case.component.js.map